function Sharing() {
	this.init();
}

Sharing.prototype = {
	init: function() {
		this.$container = $('.share-block-js');
		this.$btnShare = this.$container.find('[data-share]');
		this.$btnShare.on('click', e => {
			e.preventDefault();
			this.initShare($(e.currentTarget));
		});
	},
	initShare: function($container) {
		const social_type = $container.attr('data-share');
		const s_title = $container.attr('data-share-title') || $('title').text();
		let s_text = $container.attr('data-share-text') || $('[property="og:description"]').text();
		const s_img = $container.attr('data-share-img') || $('[property="og:image"]').attr('src');
		const url = window.location.href;

		s_text = s_text.replace(/<.*?>/g, '').slice(0, 100) + '...';

		switch (social_type) {
			case 'vk':
				this.vk(url, s_title, s_text, s_img);
				break;
			case 'fb':
				this.fb(url, s_title, s_text, s_img);
				break;
			case 'ok':
				this.ok(url, s_title, s_text, s_img);
				break;
			case 'tw':
				this.tw(url, s_title, s_text, s_img);
				break;
			case 'tg':
				this.tg(url, s_title, s_text, s_img);
				break;
			default:
				break;
		}
	},
	vk: function(url, title, text, img) {
		let share_url = 'http://vkontakte.ru/share.php?';
		share_url += 'url=' + encodeURIComponent(url);
		share_url += '&title=' + encodeURIComponent(title);
		share_url += '&description=' + encodeURIComponent(text);
		share_url += '&image=' + encodeURIComponent(img);
		share_url += '&noparse=true';
		this._popup(share_url);
	},
	fb: function(url, title, text, img) {
		text = text.replace(/&nbsp;/g, ' ');
		// img = document.location.href + img;
		// eslint-disable-next-line
		FB.ui(
			{
				method: 'feed',
				name: title,
				link: url,
				picture: img,
				description: text,
			},
			function(response) {}
		);
	},
	ok: function(url, title, text, img) {
		let share_url = 'https://connect.ok.ru/offer';
		share_url += '?url=' + url;
		share_url += '&title=' + title;
		share_url += '&imageUrl=' + img;
		this._popup(share_url);
	},
	tg: function(url, title, text, img) {
		let share_url = 'https://telegram.me/share/url';
		share_url += '?url=' + url;
		share_url += '&text=' + title;
		this._popup(share_url);
	},
	tw: function(url, title, text, img) {
		let tw_text = $('meta[name="twitter:description"]').attr('content');
		tw_text = tw_text.slice(0, 112) + '...';
		let share_url = 'http://twitter.com/share?';
		share_url += 'text=' + encodeURIComponent(tw_text);
		share_url += '&url=' + encodeURIComponent(url);
		share_url += '&counturl=' + encodeURIComponent(url);
		this._popup(share_url);
	},
	_popup: function(url) {
		window.open(url, '', 'toolbar=0,status=0,width=626,height=436');
	},
};

module.exports = new Sharing();
